<article class="ads-expenses-datatable">
  <table mat-table [dataSource]="dataSource" class="mat-table-container">
    <ng-container matColumnDef="media">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">{{ element.media }}</td>
    </ng-container>
    <ng-container matColumnDef="myExpenses">
      <th mat-header-cell *matHeaderCellDef>Mes dépenses (FCFA)</th>
      <td mat-cell *matCellDef="let element">{{ element.myExpenses }}</td>
    </ng-container>
    <ng-container matColumnDef="competingExpenses">
      <th mat-header-cell *matHeaderCellDef>Dépenses concurrents (FCFA)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.competingExpenses }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="openAddDialog()"
      class="ads-expenses-datatable__table-line"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
